import { NgModule } from '@angular/core';
import { LogoLoaderComponent } from './logo-loader.component';

@NgModule({
  imports: [LogoLoaderComponent],
  exports: [LogoLoaderComponent],
})
export class LogoLoaderModule {}
